var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRehabilitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke-width:0px;}.cls-2{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.18,7.92C26.94,7.92,8.1,26.76,8.1,50s18.84,42.08,42.08,42.08c13.9,0,26.23-6.74,33.89-17.13l-3.81.58c-1.35.21-2.61-.72-2.82-2.07-.21-1.35.72-2.61,2.07-2.82l9.79-1.5c1.35-.21,2.61.72,2.82,2.07l1.5,9.79c.21,1.35-.72,2.61-2.07,2.82-1.35.21-2.61-.72-2.82-2.07l-.6-3.95c-8.56,11.66-22.36,19.23-37.94,19.23-25.97,0-47.03-21.06-47.03-47.03S24.21,2.97,50.18,2.97c1.37,0,2.48,1.11,2.48,2.48s-1.11,2.48-2.48,2.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.36,4.57c-1.32-.35-2.68.43-3.03,1.75s.43,2.68,1.75,3.03c1.8.48,3.54,1.07,5.22,1.77,1.26.52,2.71-.08,3.23-1.34.52-1.26-.08-2.71-1.34-3.23-1.87-.77-3.82-1.43-5.83-1.97Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.82,12.68c-1.08-.83-2.64-.63-3.47.46-.83,1.08-.63,2.64.46,3.47,2.94,2.25,5.54,4.87,7.76,7.77.83,1.09,2.39,1.29,3.47.46,1.09-.83,1.29-2.39.46-3.47-2.48-3.24-5.39-6.17-8.68-8.69Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.64,32c-.52-1.26-1.97-1.86-3.24-1.34-1.26.52-1.86,1.97-1.34,3.24,1.4,3.37,2.37,6.94,2.85,10.61.18,1.36,1.42,2.31,2.78,2.13,1.36-.18,2.31-1.42,2.13-2.78-.54-4.11-1.62-8.09-3.19-11.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.82,56.14c.18-1.36-.77-2.6-2.13-2.78-1.36-.18-2.6.77-2.78,2.13-.24,1.8-.6,3.6-1.08,5.4-.35,1.32.43,2.68,1.75,3.03,1.32.35,2.68-.43,3.03-1.75.54-2.01.94-4.02,1.21-6.03Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m60.09,25.25c0-2.73-2.22-4.95-4.95-4.95h-9.9c-2.73,0-4.95,2.22-4.95,4.95v14.85h-14.85c-2.73,0-4.95,2.22-4.95,4.95v9.9c0,2.73,2.22,4.95,4.95,4.95h14.85v14.85c0,2.73,2.22,4.95,4.95,4.95h9.9c2.73,0,4.95-2.22,4.95-4.95v-14.85h14.85c2.73,0,4.95-2.22,4.95-4.95v-9.9c0-2.73-2.22-4.95-4.95-4.95h-14.85v-14.85Zm14.85,29.7v-9.9h-19.8v-19.8h-9.9v19.8h-19.8v9.9h19.8v19.8h9.9v-19.8h19.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehabilitation);
export default __webpack_public_path__ + "static/media/rehabilitation.4a531d4a6bde9fc54a6cfac919881b8f.svg";
export { ForwardRef as ReactComponent };